import ServerDirections from '@/config/server-directions'
function getFileURL (fileId) {
  if (!fileId) return null
  if (fileId.startsWith('http') || fileId.startsWith('data')) {
    return fileId
  } else {
    return ServerDirections.PUBLIC_FILES.replace('{fileId}', fileId)
  }
}
export {
  getFileURL,
}
